import reducer from "./reducers";

import * as employeeActions from "./actions";

export { employeeActions };

export default reducer;
